export function TestimonialsSection() {
  const testimonials = [
    {
      type: '生徒',
      name: '中1 Gさん',
      rating: 5,
      comment: '先生が優しくて、わからないところを何度も教えてくれます。数学が苦手だったけど、今は楽しくなりました。テストの点数も上がって嬉しいです。',
      icon: 'ri-user-smile-line'
    },
    {
      type: '保護者',
      name: 'Hさんのお母様',
      rating: 5,
      comment: '家で全く勉強しなかった子が、塾に通い始めてから自分から机に向かうようになりました。提出物も期限内に出せるようになり、本当に感謝しています。',
      icon: 'ri-parent-line'
    },
    {
      type: '生徒',
      name: '中2 Iさん',
      rating: 5,
      comment: '部活が忙しくても、自分のペースで勉強できるのが良いです。テスト前は集中的に対策してくれるので、点数が上がりました。自習室も使えて便利です。',
      icon: 'ri-user-smile-line'
    },
    {
      type: '保護者',
      name: 'Jさんのお父様',
      rating: 5,
      comment: '定期的に学習報告をいただけるので、子どもの様子がよくわかります。先生方が熱心に指導してくださり、成績も着実に上がっています。',
      icon: 'ri-parent-line'
    },
    {
      type: '生徒',
      name: '中1 Kさん',
      rating: 5,
      comment: '英語が全然わからなかったけど、基礎から教えてもらって理解できるようになりました。小テストで確認してくれるので、ちゃんと覚えられます。',
      icon: 'ri-user-smile-line'
    },
    {
      type: '保護者',
      name: 'Lさんのお母様',
      rating: 5,
      comment: '中2になって成績が下がり心配していましたが、こちらの塾に通い始めてから持ち直しました。勉強のやり方を教えていただき、本人も自信がついたようです。',
      icon: 'ri-parent-line'
    }
  ];

  return (
    <section className="py-16 px-4 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            生徒・保護者の声
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            廿日市市の学習塾で、多くの方にご満足いただいています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className={`w-12 h-12 flex items-center justify-center rounded-full ${testimonial.type === '生徒' ? 'bg-blue-100' : 'bg-green-100'}`}>
                    <i className={`${testimonial.icon} text-2xl ${testimonial.type === '生徒' ? 'text-blue-600' : 'text-green-600'}`}></i>
                  </div>
                  <div>
                    <p className={`text-xs font-bold ${testimonial.type === '生徒' ? 'text-blue-600' : 'text-green-600'}`}>
                      {testimonial.type}
                    </p>
                    <p className="text-sm font-bold text-gray-800">{testimonial.name}</p>
                  </div>
                </div>
                <div className="flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>

              <p className="text-sm text-gray-700 leading-relaxed">
                {testimonial.comment}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            <strong>中学生の塾</strong>として、<strong>定期テスト対策</strong>と<strong>学習習慣づけ</strong>に力を入れています。<br />
            廿日市市で学習塾をお探しなら、ぜひ一度ご相談ください。
          </p>
        </div>
      </div>
    </section>
  );
}
